/** Firebase's local persistence key for the default app's signed-in user. */
export const persistedUserKey = (apiKey: string): string => `firebase:authUser:${apiKey}:[DEFAULT]`;

/**
 * Whether Firebase has a signed-in user stored on this device, checked without loading the SDK, so a visitor who has
 * never signed in loads nothing from Firebase. False when storage is unavailable.
 */
export const hasPersistedUser = (apiKey: string, storage: () => Storage = () => window.localStorage): boolean => {
  try {
    return Boolean(apiKey) && storage().getItem(persistedUserKey(apiKey)) !== null;
  } catch {
    return false;
  }
};
